













































import {Vue, Component, Prop, PropSync, Watch} from 'vue-property-decorator';
import {Image} from "@/types/CheckoutServerData";

@Component({})
export default class Lightbox extends Vue {
    @Prop({required: true})
    private readonly images!: Image[];

    @Prop({required: false, default: false})
    private readonly renderBackground!: boolean;

    @PropSync('selectedImageIndex', {required: true, default: null})
    private syncSelectedImageIndex!: number | null;

    private get selectedImage(): Image {
        if (this.syncSelectedImageIndex === null) {
            return this.images[0];
        }
        return this.images[this.syncSelectedImageIndex];
    }

    private prevImage(): void {
        if (this.syncSelectedImageIndex === null) {
            return;
        }
        if (this.syncSelectedImageIndex === 0) {
            this.syncSelectedImageIndex = this.images.length - 1;
        } else {
            this.syncSelectedImageIndex--;
        }
    }

    private nextImage(): void {
        if (this.syncSelectedImageIndex === null) {
            return;
        }
        if (this.syncSelectedImageIndex === this.images.length - 1) {
            this.syncSelectedImageIndex = 0;
        } else {
            this.syncSelectedImageIndex++;
        }
    }
}
